import './bootstrap';
import '../css/app.css';
import 'react-quill/dist/quill.snow.css';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import '../js/I18n/i18n'
import AuthLayout from './Layouts/AuthLayout';
import { ThemeProvider } from './Layouts/ThemeContext';
import { ConfigProvider } from 'antd';

const appName = import.meta.env.VITE_APP_NAME || 'Dr. Muhammad Noor Khan General Hospital';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.tsx`, import.meta.glob('./Pages/**/*.tsx'))
        .then((module: any) => {
            const page = module.default;
            page.layout = page.layout || ((page: any) => <AuthLayout>{page}</AuthLayout>);
            return module;
        }),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <ConfigProvider
            theme={{
                token: {
                    fontFamily: 'Almarai',
                },
              }}
            >
            <ThemeProvider>
                <App {...props} />
            </ThemeProvider>
            </ConfigProvider>
            );
    },
    progress: {
        color: '#FFB200',
        showSpinner:true
    },
});
